import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const StyledUl = styled.ul`
  list-style-type: none;
  margin: 0;
`
const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const Scheiner = () => (
  <li>
    <strong>Dr. Scheiner</strong>
    <StyledUl>
      <li>
        <StyledLink to="/about">Meet Dr. Scheiner</StyledLink>
      </li>
      <li>
        <StyledLink to="/about/professional-resume">
          Curriculum Vitae
        </StyledLink>
      </li>
      <li>
        <StyledLink to="/reviews">
          Patient Reviews
        </StyledLink>
      </li>
    </StyledUl>
  </li>
)

export default Scheiner
